import { Icon, Values } from '@graftcode/design-system'

import { Runtime } from '@/core/enums/runtime.enum'

/**
 * Class / type level: language runtime icon (JS, C#, PHP, Java, …).
 */
export const getRuntimeIcon = (runtimeName: Runtime): Values<typeof Icon> => {
  switch (runtimeName) {
    case Runtime.Nodejs:
      return Icon.DSJsColor
    case Runtime.Netcore:
      return Icon.DSCSharpColor
    case Runtime.Python:
      return Icon.DSPythonColor
    case Runtime.Jvm:
      return Icon.DSJavaColor
    case Runtime.Ruby:
      return Icon.DSRubyColor
    case Runtime.Php:
      return Icon.DSPhpColor
    default:
      return Icon.DSJsColor
  }
}
